import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import {
  TreePillsInput,
  TreePillsInputProps,
} from "../../../../-components/tree/tree-pills-input"
import {
  Empty,
  TreeInfo,
} from "../../../../@client/Theasoft_ApiServer__Utils_TreeBase"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"
import { radioNodeRenderer } from "../../../../-components/tree/radio-node-renderer"

interface Props extends Omit<TreePillsInputProps<TreeInfo<Empty>>, "tree"> {
  category: ResourceTypeCategory
}

export function ResourceTypeTreeSelect({ category, ...props }: Props) {
  const { data: tree } = useSuspenseQueryGet(
    "/api/ResourceType/GetResourceTypeTree",
    { category }
  )
  return (
    <TreePillsInput {...tree} {...props} nodeRenderer={radioNodeRenderer} />
  )
}
